import React, {Component} from "react";


class OutputHtml extends Component {
    constructor(props) {
        super(props);

        this.state = {
            method: ""
        };

        let regex = /@click=\w+/;
        if (regex.test(this.props.blockItem.label)) {
            this.state = {method: "" + regex.exec(this.props.blockItem.label)[0].split("=")[1]};
        }
        this.click = this.click.bind(this);
    }

    click() {
        this.props.externalCall(this.state.method);
    }

    render() {
        return (
            <div onClick={this.click} dangerouslySetInnerHTML={{__html: this.props.blockItem.label}}></div>
        );
    }
}

export default OutputHtml;